export function formatRelativeTime(iso: string | null | undefined): string | null {
    if (!iso) return null;
    const then = new Date(iso).getTime();
    if (Number.isNaN(then)) return null;

    const diffMs = Date.now() - then;
    const minutes = Math.round(diffMs / 60_000);
    if (minutes < 1) return "moments ago";
    if (minutes < 60) return `${minutes} ${minutes === 1 ? "minute" : "minutes"} ago`;

    const hours = Math.round(minutes / 60);
    if (hours < 24) return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;

    const days = Math.round(hours / 24);
    if (days < 14) return `${days} ${days === 1 ? "day" : "days"} ago`;

    const weeks = Math.round(days / 7);
    if (weeks < 9) return `${weeks} ${weeks === 1 ? "week" : "weeks"} ago`;

    const months = Math.round(days / 30);
    if (months < 12) return `${months} ${months === 1 ? "month" : "months"} ago`;

    const years = Math.round(days / 365);
    return `${years} ${years === 1 ? "year" : "years"} ago`;
}
